import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";


export default function UpdateKataSlips() {
  const [search, setSearch] = useState("");
  
  const [kataSlips, setKataSlips] = useState([]);
  const navigate = useNavigate();
  const token = sessionStorage.getItem("token");

  /* =========================
     FETCH ALL DATA
  ========================= */
    const fetchKataSlips = async () => {
    try {
      const res = await axios.get(
        "https://irc.zentelex.com/api/delete/kataslip",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

    setKataSlips(res.data.data || []);
    } catch (error) {
      console.error(error);
    }
  };

   useEffect(() => {
    fetchKataSlips();
}, []);

   const handleEdit = (item) => {
  navigate(`/kataslip/edit/${item.id}`);
};
   
   const filteredKataSlips = kataSlips.filter((item) => {
  const text = search.toLowerCase();

  return (
    item.crdNo?.toLowerCase().includes(text) ||
    item.cddNo?.toLowerCase().includes(text) ||
    item.vehicleNo?.toLowerCase().includes(text) ||
    item.product?.toLowerCase().includes(text) ||
    item.companyName?.toLowerCase().includes(text)
  );
});
 
  return (
    <div className="container mt-4">
      <div className="card shadow-lg border-0">
        <div className="card-header bg-danger text-white">
          <h4 className="mb-0">Update Kata Slip</h4>
        </div>

        <div className="mb-3">
          <input
            type="text"
            className="form-control border-primary"
            placeholder="🔍 Search CRD / CDD / Vehicle / Product / Company..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <div className="card-body table-responsive">
          <table className="table table-hover table-bordered align-middle">
            <thead className="table-dark">
              <tr>
                <th>#</th>
                 <th>CRD No</th>
                 <th>CDD No</th>
                 <th>Vehicle No</th>
                 <th>Product</th>
                 <th>Company</th>
                 <th>Date</th>
                 <th>Net Wt</th>
                 <th>Action</th> 
	     </tr>
            </thead>

            <tbody>
              {filteredKataSlips.length === 0 ? (
                <tr>
                  <td colSpan="9" className="text-center">
                    No Records Found
                  </td>
                </tr>
              ) : (
                filteredKataSlips.map((item, index) => (
                  <tr key={item.id}>
                    <td>{index + 1}</td>

                    {/* Correct fields */}
                     <td>{item.crdNo}</td>
                     <td>{item.cddNo}</td>
                     <td>{item.vehicleNo}</td>
                     <td>{item.product}</td>
                     <td>{item.companyName}</td>
                     <td>{item.dateIn || item.dateOut}</td>
                     <td>{item.netWt}</td>
                    {/* truck_nos is ARRAY */}

                    <td>
                    
		     <button
                      className="btn btn-primary btn-sm"
                      onClick={() => handleEdit(item)}
                       >
                     ✏️ Update
                    </button>
                     
		   </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
